import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Paper, Animation } from 'components'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    optionPadding: '0.5rem 1rem',
    fontSize: '0.9rem',
    width: '8rem'
}

const Container = styled.div`
    width: ${props => props.styles.width};
    border-radius: 5px;
    font-size: ${props => props.styles.fontSize};
    background-color: ${props => props.styles.backgroundColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
    max-height: 30vh;
    overflow-y: auto;
`

const OptionBlock = styled.div`
    box-sizing: border-box;
    border-radius: 5px;
    width: 100%;
    padding: ${props => props.styles.optionPadding};
    cursor: pointer;
    box-sizing: border-box;
    background-color: ${props => props.styles.backgroundColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Options = props => {
    const {
        onSelectHandler,
        closeHandler,
        options,
        styles
    } = props
    let updatedStyle = Object.assign({}, defaultStyle, styles)
    const onClickHandler = (event, val) => {
        event.preventDefault()
        onSelectHandler(val)
        closeHandler()
    }

    // Option blocks
    let optionBlocks = []
    for (const [key, value] of Object.entries(options)) {
        optionBlocks.push(<OptionBlock styles={(({ width, ...o }) => o)(updatedStyle)} key={key} onClick={(event) => {onClickHandler(event, key)}}>{value}</OptionBlock>)
    }
    return (
        <Paper style={{margin: '0.2rem 0 0 0'}}>
            <Container styles={(({ padding, ...o }) => o)(updatedStyle)}>
                {optionBlocks}
            </Container>
        </Paper>
    )
}

export default Options;

Options.propTypes = {
    onSelectHandler: PropTypes.func,
    closeHandler: PropTypes.func,
    backgroundColor: PropTypes.string,
    options: PropTypes.object,
    width: PropTypes.string
}